import React, { useState } from "react"
import { Box, Typography } from "@mui/material"
import { PushPin } from "@mui/icons-material"
import LocationOnIcon from "@mui/icons-material/LocationOn"

const JobAnimatedAddressComponent = ({
    instruction,
    title,
    content,
    positionOffset = "10%", // Default value
    isMinimalView,
    onPress,
}: {
    instruction?: string
    title?: string
    content?: string
    positionOffset?: string | number // New prop for dynamic positioning
    isMinimalView?: boolean // Prop to control minimal view
    onPress?: () => void
}) => {
    const [isOpen, setIsOpen] = useState(!isMinimalView)

    const handleClick = () => {
        setIsOpen(!isOpen) // Toggle view
    }

    return (
        <Box
            style={{
                transition: "transform 0.5s",
                transform: isOpen ? "translateX(-70%)" : "none",
            }}
            position={"absolute"}
            bgcolor={"primary.main"}
            boxShadow={3}
            borderRadius={isMinimalView ? 4 : 6}
            display={"flex"}
            alignItems={"center"}
            paddingY={1}
            paddingX={2}
            width={"93%"}
            right={"-77vw"}
            top={positionOffset} // Dynamically controlled top position
        >
            {isMinimalView ? (
                // Minimal view: Show only icon and centered text
                <Box display={"flex"} width={"100%"} alignItems={"center"}>
                    <LocationOnIcon
                        fontSize="large"
                        style={{ color: "white", marginRight: 8 }}
                        onClick={handleClick} // Toggle view
                    />
                    <Typography lineHeight={"1.2"} variant="subtitle1" onClick={onPress} sx={{ color: "white" }}>
                        {instruction}
                    </Typography>
                </Box>
            ) : (
                // Full view: Show all UI components
                <>
                    <PushPin
                        fontSize="large"
                        style={{ color: "white", marginRight: 3, transform: "rotate(-90deg)" }}
                        onClick={handleClick}
                    />
                    <Box>
                        {instruction && (
                            <Typography variant="h6" sx={{ color: "white" }}>
                                {instruction}
                            </Typography>
                        )}
                        <Typography lineHeight={"1.2"} variant="subtitle1" sx={{ color: "white" }}>
                            {title}
                        </Typography>
                        {content && (
                            <Typography variant="subtitle2" sx={{ color: "white" }}>
                                {content ?? "Description"}
                            </Typography>
                        )}
                    </Box>
                </>
            )}
        </Box>
    )
}

export default JobAnimatedAddressComponent
